// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6nEFlWkix{margin:10px 0;flex:1 0 auto;overflow:hidden}\n", ""]);
// Exports
exports.locals = {
	"navigation": "_6nEFlWkix"
};
module.exports = exports;
